var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNewsletterBro(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 63.551,
    height: 63.962,
    viewBox: "0 0 63.551 63.962",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Newsletter-bro",
    transform: "translate(-293.249 -208.047)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Screen--inject-228",
    transform: "translate(293.95 208.68)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9091",
    "data-name": "Path 9091",
    d: "M259.246,139.058l.092-.072h-.18l-1.61-1.21L229.654,116.81l-29.5,22.176h-.184l.1.068-.1.072h.192l29.756,21.4,29.232-21.4h.188Z",
    transform: "translate(-197.961 -110.755)",
    fill: "#4eb6ee",
    stroke: "#4eb6ee",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3520",
    "data-name": "Rectangle 3520",
    width: 39.822,
    height: 49.427,
    transform: "translate(11.306 8.273)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9092",
    "data-name": "Path 9092",
    d: "M266.67,143.513c0,5.727-2.6,9.025-5.291,9.025a2.011,2.011,0,0,1-2.285-1.969,3.033,3.033,0,0,1-2.982,1.969c-2.165-.032-2.918-1.853-2.657-4.426l.316-2.894c.26-2.629,1.445-4.278,3.6-4.222a2.4,2.4,0,0,1,2.489,1.909l.2-1.793h1.969l-.868,8.3c-.088.664.116,1.245.836,1.245,2.229,0,2.982-4.254,2.954-7.088,0-4-1.881-6.624-6.219-6.624-5.783,0-8.473,4.8-8.473,11.282,0,5,2.281,8,7.316,8a8.66,8.66,0,0,0,5.7-1.825l-.172,2a9.51,9.51,0,0,1-5.639,1.561c-6.363,0-9.141-3.9-9.141-9.861,0-6.884,3.3-12.927,10.47-12.927C264.6,135.172,266.67,138.71,266.67,143.513Zm-10.962,1.909-.26,2.6c-.172,1.5.292,2.573,1.649,2.605s2.053-1.013,2.229-2.577l.288-2.774c.144-1.361-.4-2.313-1.677-2.313-1.341-.044-2.053.884-2.229,2.445Z",
    transform: "translate(-226.96 -121.773)",
    fill: "#4eb6ee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9093",
    "data-name": "Path 9093",
    d: "M199.97,172.22v34.415h59.368V172.22l-29.684,17.209Z",
    transform: "translate(-197.961 -143.989)",
    fill: "#4eb6ee",
    stroke: "#4eb6ee",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9094",
    "data-name": "Path 9094",
    d: "M199.97,232.425l29.684-17.205,29.684,17.205",
    transform: "translate(-197.961 -169.779)",
    fill: "none",
    stroke: "#4eb6ee",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_539",
    "data-name": "Line 539",
    x2: 2.978,
    y2: 2.261,
    transform: "translate(2.457 18.382)",
    fill: "none",
    stroke: "#4eb6ee",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_540",
    "data-name": "Line 540",
    x2: 1.213,
    y2: 0.921,
    transform: "translate(0 16.513)",
    fill: "none",
    stroke: "#4eb6ee",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_541",
    "data-name": "Line 541",
    x2: 4.999,
    y2: 4.783,
    transform: "translate(3.914 1.953)",
    fill: "none",
    stroke: "#4eb6ee",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_542",
    "data-name": "Line 542",
    x2: 0.632,
    y2: 1.889,
    transform: "translate(19.579 2.021)",
    fill: "none",
    stroke: "#4eb6ee",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_543",
    "data-name": "Line 543",
    x2: 0.368,
    y2: 1.105,
    transform: "translate(18.906 0)",
    fill: "none",
    stroke: "#4eb6ee",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_544",
    "data-name": "Line 544",
    x1: 5.435,
    y2: 4.13,
    transform: "translate(56.715 16.513)",
    fill: "none",
    stroke: "#4eb6ee",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_545",
    "data-name": "Line 545",
    x1: 3.33,
    y2: 3.186,
    transform: "translate(53.241 3.55)",
    fill: "none",
    stroke: "#4eb6ee",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_546",
    "data-name": "Line 546",
    x1: 1.113,
    y2: 1.069,
    transform: "translate(57.123 1.953)",
    fill: "none",
    stroke: "#4eb6ee",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_547",
    "data-name": "Line 547",
    x1: 1.305,
    y2: 3.91,
    transform: "translate(41.939 0)",
    fill: "none",
    stroke: "#4eb6ee",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_548",
    "data-name": "Line 548",
    y2: 3.042,
    transform: "translate(31.725 0)",
    fill: "none",
    stroke: "#4eb6ee",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewsletterBro);
export default __webpack_public_path__ + "static/media/Newsletter-bro.bdee72ffdcfd6843e7b7d3bf0e1d4ce0.svg";
export { ForwardRef as ReactComponent };